import React, { useRef } from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { motion, useScroll, useTransform } from "framer-motion"

import ArrowUpRight from "../css/assets/arrow-up-right.inline.svg"
import ArrowRight from "../css/assets/arrow-right.inline.svg"
import "../css/island-card.css"

function useParallax(value, distance) {
  return useTransform(value, [0, 1], [-distance, distance])
}

const IslandCard = ({ name, description, image, link }) => {
  const refImage = useRef(null)
  const { scrollYProgress } = useScroll({ target: refImage })

  if (typeof window !== "undefined") {
    if (window.innerWidth < 992 && window.innerHeight > window.innerWidth) {
      // const yMobile = useParallax(scrollYProgress, 100)
      // const yTitleMobile = useParallax(scrollYProgress, 0)
      return (
        <div className={`island-card `}>
          <motion.div
            whileInView={{ opacity: 1, y: 30 }}
            initial={{ opacity: 0, y: 150 }}
            transition={{ duration: 0.5 }}
            ref={refImage}
          >
            <h2 className="island-name">{name}</h2>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, y: 30 }}
            initial={{ opacity: 0, y: 150 }}
            transition={{ duration: 0.5 }}
            ref={refImage}
          >
            <div className="island-card-text">
              <p>{description}</p>
              <Link to={link}>
                <div className="island-card-link">
                  <span>Discover {name}</span>
                  <ArrowUpRight />
                </div>
              </Link>
            </div>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1, y: 50 }}
            initial={{ opacity: 0, y: 150 }}
            transition={{ duration: 0.5 }}
            ref={refImage}
          >
            <GatsbyImage
              image={image}
              alt={name}
              className="island-card-image"
            />
          </motion.div>
        </div>
      )
    } else {
      // console.log(window.innerWidth / window.innerHeight)
      // yTitle should be around 300 when on normal screen
      // around 50 when on portrait desktop

      let y = useParallax(scrollYProgress, 250)
      let yTitle = useParallax(scrollYProgress, 300)

      if (window.innerWidth / window.innerHeight < 1) {
        y = useParallax(scrollYProgress, 100)
        yTitle = useParallax(scrollYProgress, 50)
      } else if (window.innerWidth / window.innerHeight > 1.8) {
        y = useParallax(scrollYProgress, 200)
        yTitle = useParallax(scrollYProgress, 350)
      }

      return (
        <div className={`island-card `}>
          <motion.div
            style={{ y: yTitle }}
            whileInView={{ opacity: 1 }}
            initial={{ opacity: 0.6 }}
            transition={{ duration: 0.5 }}
            ref={refImage}
          >
            <h2 className="island-name">{name}</h2>
          </motion.div>
          <motion.div
            whileInView={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="island-card-content"
          >
            <GatsbyImage
              image={image}
              alt={name}
              className="island-card-image"
            />
            <motion.div
              style={{ y }}
              whileInView={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="island-card-text">
                <p>{description}</p>
                <div className="island-card-links">
                  <Link to={link}>
                    <div className="island-card-link">
                      <span>Discover {name}</span>
                      <ArrowUpRight />
                    </div>
                  </Link>
                  <Link to={"/inquiries"}>
                    <div className="island-card-link island-card-link-plain">
                      <span>Make Inquiry</span>
                      <ArrowRight />
                    </div>
                  </Link>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      )
    }
  }
}

export default IslandCard
